/** Inline handler for SweetAlert HTML inputs — allows digits and one decimal point */
export const DECIMAL_AMOUNT_ONINPUT =
    "this.value=this.value.replace(/[^\\d.]/g,'').replace(/(\\..*)\\./g,'$1')";

export const round2 = (n: number) => Math.round(n * 100) / 100;

export const amountsMatch = (a: number, b: number) => round2(a) === round2(b);

export const sanitizeDecimalInputValue = (value: string) => {
    let v = value.replace(/[^\d.]/g, "");
    const parts = v.split(".");
    if (parts.length > 2) {
        v = parts[0] + "." + parts.slice(1).join("");
    }
    return v;
};

export const parsePaymentAmount = (value: string): number => {
    const trimmed = value.trim();
    if (!trimmed) return NaN;
    return round2(Number(trimmed));
};

const formatWithCommas = (amount: number) =>
    amount.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export const formatAmount = (amount: number | string | undefined | null) => {
    if (amount == null || amount === "" || isNaN(Number(amount))) return "0.00";
    return formatWithCommas(round2(Number(amount)));
};

export const formatCurrency = (amount: number | string | undefined | null) => {
    if (amount == null || amount === "" || isNaN(Number(amount))) return "0.00";
    return formatWithCommas(Number(amount));
};

export const formatRupeeAmount = (value: string | number | null | undefined) => {
    if (value == null || value === "") return "-";
    return `₹${formatCurrency(value)}`;
};

export const formatNumericAmount = (
    value: string | number | null | undefined,
    fallback = "-"
) => {
    if (value == null || value === "") return fallback;
    const num = Number(value);
    if (isNaN(num)) return String(value);
    return formatCurrency(value);
};
